import { Directive, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { debounceTime, Subscription } from 'rxjs';
import { SessionStorageUtil } from '../utils/session-storage.util';

@Directive({
  standalone: false,
  selector: '[appPersistForm]'
})
export class PersistFormDirective implements OnInit, OnDestroy {
  @Input('appPersistForm') form!: FormGroup;
  @Input() persistKey!: string;          // required unique key
  @Input() debounceMs = 250;
  @Output() restored = new EventEmitter<any>();

  private sub?: Subscription;

  ngOnInit(): void {
    if (!this.form || !this.persistKey) return;

    // 1) Restore (before callers make API decisions)
    const saved = SessionStorageUtil.get<any>(this.persistKey);
    if (saved) {
      this.form.patchValue(saved, { emitEvent: false });
      this.restored.emit(saved);
    }

    // 2) Autosave on change
    this.sub = this.form.valueChanges
      .pipe(debounceTime(this.debounceMs))
      .subscribe(v => SessionStorageUtil.set(this.persistKey, v));
  }

  clear(): void {
    SessionStorageUtil.remove(this.persistKey);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
